import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router";
import { useAuth } from "../../utility/useAuth";
import { useStoreActions } from "../../store";
import { getCurrentUser } from "../../services/ApiService";
import { DefaultLayout } from "../../layouts/Default";

enum AuthState {
  LOADING,
  AUTHORISED,
  AUTHENTICATED_NOT_LICENCED,
  UNAUTHORISED,
}

interface IPrivateRoute {
  children: React.ReactElement;
}

export const PrivateRoute = (props: IPrivateRoute) => {
  const location = useLocation();
  const auth = useAuth();
  const [authorised, setAuthorised] = useState(AuthState.LOADING);
  const path = encodeURIComponent(location?.pathname || "");
  const params = encodeURIComponent(location?.search || "");

  const { user: userProfile } = useStoreActions((actions) => actions);

  useEffect(() => {
    auth.getUser().then((user) => {
      if (user && user?.access_token) {
        getCurrentUser(auth)
          .then((userInfo) => {
            const profile: any = user && user.profile ? user.profile : null;
            userProfile.setAuthenticated(!!profile);
            userProfile.setCompany(profile ? profile.company?.trim() : "");
            userProfile.setEmail(profile ? profile.email?.trim() : "");
            userProfile.setFirstName(profile ? profile.given_name?.trim() : "");
            userProfile.setFullName(profile ? profile.full_name?.trim() : "");
            userProfile.setLastName(profile ? profile.family_name?.trim() : "");
            userProfile.setLanguage("en");
            userProfile.setInfo(userInfo);

            setAuthorised(
              user && user.id_token
                ? AuthState.AUTHORISED
                : AuthState.UNAUTHORISED
            );
          })
          .catch((error) => {
            console.error(`User not authorised ${JSON.stringify(user)}`);
            const profile: any = user && user.profile ? user.profile : null;
            userProfile.setFullName(profile ? profile.name?.trim() : "");
            setAuthorised(AuthState.AUTHENTICATED_NOT_LICENCED);
          });
      } else {
        setAuthorised(AuthState.UNAUTHORISED);
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    });
  }, [location.pathname]); // eslint-disable-line

  if (authorised === AuthState.LOADING) {
    return <span>Loading ....</span>;
  }

  if (authorised === AuthState.AUTHENTICATED_NOT_LICENCED) {
    return (
      <DefaultLayout>
        <div className="text-danger">
          <h1>Authentication Error: You don't have access</h1>
        </div>
      </DefaultLayout>
    );
  }

  if (authorised === AuthState.UNAUTHORISED) {
    return (
      <Navigate
        to={{
          pathname: "/login",
        }}
        replace state={{ from: location }}
      />
    );
  }

  return props.children;
};
